
import { Component, Ref, Prop, Vue } from 'vue-property-decorator'
import GradeTip from '@/components/organisms/GradeTip.vue'
import SelectModal from '@/components/templates/SelectModal.vue'
import { GradeCode } from '@/const/GradeCode'

/**
 * 学年選択モーダル
 */
@Component({
  components: {
    GradeTip,
    SelectModal,
  },
})
export default class ModalSelectGrade extends Vue {
  /** 選択用モーダル */
  @Ref()
  private selectModal!: SelectModal

  /** ボタン押下時のイベント */
  @Prop()
  private eventSubmitGrade!: (code: string) => Promise<void>

  /** 生徒情報 */
  private student = this.$appCookies.authStudent.get()

  /**
   * 学年コード一覧
   *
   * @returns 学年コードのリスト
   */
  private get gradeCodeList(): string[] {
    return GradeCode.getSmallerList(this.student.gradeCode).map((grade) => grade.code)
  }

  /**
   * ボタン押下時のイベント
   */
  private async submitGrade(): Promise<void> {
    this.selectModal.hide()
    await this.eventSubmitGrade(this.selectModal.currentItemCode)
  }

  /**
   * モーダルを開く
   *
   * @param currentGradeCode 現在の学年コード
   */
  public show(currentGradeCode: string): void {
    this.selectModal.show(currentGradeCode)
  }
}
